import type {AppRouteModule} from '@/router/types';
import {t} from '@/hooks/web/useI18n';

const appRoute: Array<AppRouteModule> = [
  {
    path: '/ngsUnitAdmin',
    name: '/ngsUnitAdmin',
    component: () =>
      import(
        /* webpackChunkName: "unitAdminPage" */ '@/views/ngsUnitAdmin/index.vue'
        ),
    meta: {
      // affix: true,
      title: t('单位管理员主页'),
    },
  },
  {
    path: '/ngsUserMainPage',
    name: '/ngsUserMainPage',
    component: () =>
      import(
        /* webpackChunkName: "ngsUserMainPage" */ '@/views/ngsUnitAdmin/zhu-ti-show.vue'
        ),
    meta: {
      // affix: true,
      title: t('主页'),
    },
  },
  {
    path: '/changeInfoMain',
    name: '/changeInfoMain',
    component: () =>
      import(
        /* webpackChunkName: "ngsUserMainPage" */ '@/views/ngsUnitAdmin/changComs/changeInfoMain.vue'
        ),
    meta: {
      // affix: true,
      title: t('厂房统计信息'),
    },
  },
  {
    path: '/unitAdminPageShow',
    name: '/unitAdminPageShow',
    component: () =>
      import(
        /* webpackChunkName: "unitAdminPage" */ '@/views/unitAdminPage/index.vue'
        ),
    meta: {
      // affix: true,
      title: t('主页'),
    },
  },
  {
    path: '/appShowByApp',
    name: 'appShowByApp',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('子应用显示'),
    },
    children: [
      {
        path: 'appMainPageShow',
        name: 'appMainPageShow',
        component: () => import(/* webpackChunkName: "appMainPageShow" */'@/layouts/layoutFrame/appFrame/AppMainPage.vue'),
        meta: {
          // affix: true,
          title: t('appMainPageShow'),
        },
      }
    ],
  }
];

export default appRoute;
